import React, { useEffect, useState } from "react";
import { StyledTablePage } from "../../styled-components/StyledTablePage.style";
import Flex from '@react-css/flex';
import { StyledForm } from "../../styled-components/StyledForm.style";
import { StyledCardWIP } from "../../styled-components/StyledCardWIP.style";

export const CardWipTotal = (
    { 
        history, 
        empresa, 
        params, 
        isOpen, 
        onAfterOpen, 
        onRequestClose, 
        title, 
        data = []
    }
) => {
    const [historicos, setHistoricos] = useState([]);

    useEffect(() => {
        var somatoria = [{
            sigla: "Total",
            qtdTimesheet: 0,
            totalHorasFaturada: 0,
            valorTotalFaturado: 0
        }];


        if (data.length == 0) {
            return;
        }
        data?.forEach(visao => {
            visao.value.forEach(val => {
                var existeSoma = somatoria.filter(som => som.sigla == val.sigla);
                if (existeSoma.length == 0) {
                    existeSoma = {
                        sigla: val.sigla,
                        qtdTimesheet: val.qtdTimesheet,
                        totalHorasFaturada: val.totalHorasFaturadasDec,
                        valorTotalFaturado: val.valorTotalFaturadoDec
                    };

                    somatoria.push(existeSoma);
                }
                else {
                    existeSoma[0].qtdTimesheet += val.qtdTimesheet;
                    existeSoma[0].totalHorasFaturada += val.totalHorasFaturadasDec;
                    existeSoma[0].valorTotalFaturado += val.valorTotalFaturadoDec;
                }

                somatoria[0].qtdTimesheet += val.qtdTimesheet;
                somatoria[0].totalHorasFaturada += val.totalHorasFaturadasDec;
                somatoria[0].valorTotalFaturado += val.valorTotalFaturadoDec;
            })
        })
        setHistoricos(somatoria);


    }, [data.length]);


    const formatDecimal = (value) => {
        if (value == null || value === undefined || value === 0) {
            return '0,00';

        }
        return value.toLocaleString('pt-br', { style: 'decimal', currency: 'BRL', minimumFractionDigits: 2, maximumFractionDigits: 2 });

    }

    return (


        <Flex>
            <StyledForm style={{ width: "100%" }}>
                <StyledTablePage>
                    <StyledCardWIP>
                        <div className="card-align">
                            <Flex className={'title-legend'}>
                                <div className="flex-title-center" style={{width: "100%"}} onClick={() => history.push(`/wip/detalhes?visao=${title}&IdEmpresa=${empresa}${params}`)}>
                                    <span className="legend-title-text-bold">{title}</span>
                                </div>
                            </Flex>


                            <StyledTablePage>
                                <table className="table table-bordered table-width">
                                    <thead>
                                        <tr className="table-legend-info">
                                            <th key='0'></th>
                                            <th key='1'>Qtd.TS</th>
                                            <th key='2'>Horas</th>
                                            <th key='3'>Valor</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {historicos.map((visao, index) => (
                                            <tr key={index} className={index == 0 ? 'primeiro-ativo-wip' : ''}>
                                                <td className="text-center">{visao.sigla}</td>
                                                <td className="text-center">{visao.qtdTimesheet}</td>
                                                <td className="text-center"> {formatDecimal(visao.totalHorasFaturada)} </td>
                                                <td className="text-center">{visao.valorTotalFaturado.toLocaleString('pt-br', { style: 'currency', currency: 'BRL', maximumFractionDigits: 2 })}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </StyledTablePage>
                        </div>
                    </StyledCardWIP>
                </StyledTablePage>
            </StyledForm>
        </Flex>

    );
};